import styled, { css } from 'styled-components';

import { Avatar, Tag, Box } from '@gympass/yoga';
import {
  AccessTimeOutlined,
  InfoOutlined,
  WarningAmberOutlined,
} from '@mui/icons-material';
import { wellzTheme } from '@wellz-theme/mui';

export const ChatListItem = styled(Box).attrs({
  as: 'li',
  d: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
})`
  padding: ${({ theme }) =>
    `${theme.yoga.spacing.medium}px ${theme.yoga.spacing.large}px`};
  cursor: pointer;
  background-color: ${({ theme, isSelected }) =>
    isSelected ? theme.yoga.colors.backgroundLight : theme.yoga.colors.white};
`;

const flexNoShrink = css`
  flex-shrink: ${({ theme }) => theme.yoga.spacing.zero};
`;

export const ChatListItemAvatar = styled(Avatar.Circle)`
  ${flexNoShrink}
  margin-right: ${({ theme }) => theme.yoga.spacing.xsmall}px;
  background-color: ${({ $bgColor }) => $bgColor};
  box-shadow: none;
`;

export const ChatListItemName = styled.span`
  flex: 1;
  line-height: ${({ theme }) => theme.yoga.lineHeights.medium}px;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
`;

export const ChatListItemLatest = styled(Box).attrs({
  d: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-end',
})`
  ${flexNoShrink}
  margin-left: ${({ theme }) => theme.yoga.spacing.xsmall}px;
`;

export const DaysUntilExpireTag = styled(Tag.Informative).attrs({
  variant: 'attention',
})``;

export const ConversationDetails = styled(Box)`
  display: flex;
  flex-direction: column;
`;

export const IconsWrapper = styled(Box)`
  display: flex;
  justify-content: flex-end;
  gap: ${wellzTheme.spacing(0.5)};

  margin-top: ${wellzTheme.spacing(1.5)};
`;

export const ScheduledMessageIcon = styled(AccessTimeOutlined)`
  width: ${wellzTheme.spacing(2)};
  height: ${wellzTheme.spacing(2)};
  fill: ${wellzTheme.palette.info.main};
`;

export const CriticalityIcon = styled(WarningAmberOutlined)`
  width: ${wellzTheme.spacing(2)};
  height: ${wellzTheme.spacing(2)};
  fill: ${wellzTheme.palette.error.main};
`;

export const UnlinkIcon = styled(InfoOutlined)`
  width: ${wellzTheme.spacing(2)};
  height: ${wellzTheme.spacing(2)};
  fill: ${wellzTheme.palette.warning.main};
`;
